var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"volume-wrapper",attrs:{"id":`volume-level-${_vm.callId}`}},[_c('img',{attrs:{"src":require("../assets/volume-icon.jpg"),"width":"17","height":"17"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }